import React from 'react'
import { Route } from 'react-router-dom'

import NotifierContainer from '@softwaredev_cegeka/stix-notifier/dist/components/NotifierContainer'

// Wrap router for passing props to child components.
export class ContentRoute extends React.Component {
    state = {
        Component: null,
    }

    LazyComponent = this.createLazyComponent()

    createLazyComponent() {
        const LazyComponent = React.lazy(() => {
            const importPromise = import(
                /* webpackExclude: /(\.test\.js$|__testTools__|\.test\.json$|\/server\/)/ */
                `src/routes/${this.props.component.replace(/^\.\//, '')}`
            )
            importPromise
                .then(() => localStorage.setItem('import-fail-count', '0'))
                .catch(ex => {
                    console.error(ex)
                    const failCount =
                        parseInt(
                            localStorage.getItem('import-fail-count'),
                            10
                        ) || 0
                    if (failCount > 2) {
                        throw ex
                    }
                    // Reload the current page when a chunk fails to load.
                    // This can happen when a new build was deployed and certain chunks don't exist anymore or were renamed, resulting in an import error.
                    localStorage.setItem('import-fail-count', failCount + 1)
                    window.location.reload()
                })
            return importPromise
        })

        return LazyComponent
    }

    render() {
        const { path, title, name } = this.props
        const { LazyComponent } = this
        return (
            <Route
                path={path}
                exact
                render={routeProps => {
                    return (
                        <>
                            <NotifierContainer />
                            <LazyComponent
                                path={path}
                                routeName={name}
                                title={
                                    title instanceof Function
                                        ? title(routeProps?.match?.params)
                                        : title
                                }
                                {...routeProps}
                            />
                        </>
                    )
                }}
            />
        )
    }
}
